import api from "@/utils/api";
import cupid_51job from "@/utils/cupid";
import common from "@/utils/common.js";
const { cupid, vapi, my } = api;

// 获取当前活动页配置
const getActivityConfig = (data) => {
  return cupid.post("/open/noauth/bcop-activity/activityPageInfoQuery", data);
};
// 查询活动页的公司列表
const getActivityCompanyList = (data, options) => {
  //0319需求：所有和职位查询相关功能的SearchResult服务端事件增加exrInfo03.fromRequestId
  if(JSON.stringify(options.property) !== '{}'){
    options.property.exrInfo03 = JSON.stringify({fromRequestId:common.getHrefParams('requestId')})
  }
  return cupid.post(
    "/open/noauth/bcop-activity/activityCompanyListQuery",
    data,
    options
  );
};
// 查询活动页的职位列表
const getActivityJobList = (data, options) => {
  //0319需求：所有和职位查询相关功能的SearchResult服务端事件增加exrInfo03.fromRequestId
  if(JSON.stringify(options.property) !== '{}'){
    options.property.exrInfo03 = JSON.stringify({fromRequestId:common.getHrefParams('requestId')})
  }
  return cupid.post(
    "/open/noauth/bcop-activity/activityJobListQuery",
    data,
    options
  );
};
// 自定义多列加滚动列表组件获取职位信息接口
const getCustomActivityJobList = (params,options) => {
   if(JSON.stringify(options.property) !== '{}'){
    options.property.exrInfo03 = JSON.stringify({fromRequestId:common.getHrefParams('requestId')})
  }
  //0417需求
  return cupid.get(
    "/open/noauth/gold-two-silver-three/search-update-job-list",
    {
      params, ...(options)
    },
  );
};
// 好职专区列表
const getGoodJobZone = () => {
  return cupid.post(
    "/open/noauth/bcop-activity/getGoodJobZone"
  );
};
// 查询好职专区资源
const getGoodJobZoneMaterial = () => {
  return cupid.post(
    "/open/noauth/bcop-activity/getGoodJobZoneMaterial"
  );
};
// 获取好职专区数据
const getSearchJobList = (params) => {
  return cupid_51job.get(
    '/open/noauth/gold-two-silver-three/search-job-list', params
  );
};

//获取小程序短链
const getWxUrl = (data) => {
  return vapi.post("/open.php?query=wx_url_link", data);
};

// 查询活动页问题列表
const getQuestionList = (data) => {
  return cupid.post("/open/noauth/bcop-activity/questionListQuery", data);
};

// 查询问题列表 - 包含1条回答信息
const queryQuestionList = (data) => {
  return cupid.post(
    "/open/noauth/bcop-activity/questionListWithAnsQuery",
    data
  );
};

// 查询投票信息
const voteListQuery = (data, options) => {
  return cupid.post("/open/noauth/bcop-activity/voteListQuery", data, options);
};

// 投票
const voteSubmit = (data, options) => {
  return cupid.post("/open/bcop-activity/voteSubmit", data, options);
};

// 新增问题
const addQuestion = (data, options) => {
  return cupid.post("/open/bcop-activity/addQuestion", data, options);
};

// 新增回答
const addAnswer = (data, options) => {
  return cupid.post("/open/bcop-activity/addAnswer", data, options);
};

// 查询公司详情
const getCompanyInfo = (data) => {
  return cupid.post("/open/noauth/bcop-activity/batchQueryCompanyInfo", data);
};

// 查询职位详情
const getJobInfo = (data) => {
  return cupid.post("/open/noauth/bcop-activity/batchQueryJobInfo", data);
};

// 问题详情，查询回答列表
const answerListQuery = (data, options) => {
  return cupid.post("/open/bcop-activity/answerListQuery", data, options);
};

// 获取微信服务号信息（51job）此接口已废
const get51JobWxConfig = (params) => {
  return my.get("/careerpost/marketing/weixin/jssdk4.php", { params });
};

// 获取名企列表
const queryComActivityCompany = (data, options) => {
  return cupid.post(
    "/open/noauth/bcop-activity/queryComActivityCompany",
    data,
    options
  );
};

// 投递简历后采集页数据查询
const getSendResumeCollectDataQuery = (data) => {
  return cupid.post("/open/bcop-activity/sendResumeCollectDataQuery", data);
};

// 投递简历后采集页数据查询
const popWindowCollectDataQuery = (data) => {
  return cupid.post("/open/bcop-activity/popWindowCollectDataQuery", data);
};
// 采集信息保存接口
const saveCollectData = (data) => {
  return cupid.post("/open/bcop-activity/saveCollectData", data);
};

// 创作者个人信息
const activityCreatorInfo = (params) => {
  console.log(params);
  return cupid.get("/open/noauth/bcop-activity/activityCreatorInfo", {
    params,
  });
};

// 职位专区
const creatorActivityList = (data) => {
  return cupid.post("/open/noauth/bcop-activity/creatorActivityList", data);
};

// 创作者关注取关
const creatorFollowSet = (data) => {
  return cupid.post("/open/bcop-activity/creatorFollowSet", data);
};
// 用户激励组件信息查询接口
const rewardInfoQuery = (data) => {
  return cupid.post("/open/bcop-activity/rewardInfoQuery", data);
};
// 奖励领取接口
const receiveAward = (data) => {
  return cupid.post("/open/bcop-activity/receiveAward", data);
};
// ai助手问题获取token
const aiAssistantToken = (data) => {
  return cupid.post("/open/bcop-activity/assistant/token", data);
};
// 查询微信公众号二维码/用户是否关注
const wechatQRCode = (data) => {
  return cupid.post("/open/noauth/bcop-activity/wechatQRCode", data);
};
// 关注接口
const followAdd = (data) => {
  return cupid.post("/open/subject-subscribe/add", data);
};
//获取是否订阅相关信息 /open/subject-subscribe/getBySubject
const getBySubject = (params) => {
  console.log(params);
  return cupid.get("/open/subject-subscribe/getBySubject", {
    params,
  });
};
// 取关open/subject-subscribe
const delSubscribe = (data) => {
  return cupid.delete("/open/subject-subscribe/" + data.id, data);
};
// 专题订阅-刷新更新时间
const viewTime = (data) => {
  return cupid.post("/open/subject-subscribe/view-time/" + data.groupId, data);
};
// 抽奖次数查询
const lotteryTimes = (data) => {
  return cupid.post("/open/bcop-activity/bigWheel/queryLotteryTimes", data);
};
// 开始抽奖
const darwLottery = (data)=>{
  return cupid.post("/open/bcop-activity/bigWheel/startLottery", data);
}
// 中奖记录查询
const queryWinRecords = (data)=>{
  return cupid.post('/open/bcop-activity/bigWheel/queryWinRecords',data)
}
// 提交领奖信息
const submitWinInfo = (data)=>{
  return cupid.post('/open/bcop-activity/bigWheel/submitWinInfo',data)
}
// C端签到列表信息
const getSignInList = (data) => {
  return cupid.post("/open/noauth/bcop-activity/getSignInList", data);
};
// C端签到接口
const signIn = (data) => {
  return cupid.post("/open/bcop-activity/signIn", data);
};
// C端获取中奖信息列表
const getWinAwardList = (data) => {
  return cupid.post("/open/bcop-activity/getWinAwardList", data);
};
// C端用户更新中奖记录(填写手机号)
const updateWinAward = (data) => {
  return cupid.post("/open/bcop-activity/updateWinAward", data);
};
//查询用户是否关注了传入的专区
const getSubscribeInfo = (data) => {
  return cupid.post("/open/bcop-activity/getSubscribeInfo", data);
};
//专题订阅-批量添加
const addBatch = (data) => {
  return cupid.post("/open/subject-subscribe/add-batch", data);
};
//赠送谁对我感兴趣条件检查
const checkGiftCondition = (params) => {
  console.log(params);
  return cupid.get("/open/gift-order/check-gift-condition", {
    params,
  });
};
//用户家庭住址列表 
const getAddresses = (params) => {
  return cupid.get("/open/user-setting/addresses", {
    params,
  });
};
// 获取跨城引导所有的城市信息/值得投城市榜单
const getCrossCityList = () => {
  return cupid.get(
    "/open/noauth/recommend/cross-city-list"
  );
};
export default {
  getActivityConfig,
  getActivityCompanyList,
  getActivityJobList,
  getCustomActivityJobList,
  getGoodJobZone,
  getGoodJobZoneMaterial,
  getSearchJobList,
  getWxUrl,
  getQuestionList,
  voteListQuery,
  voteSubmit,
  addQuestion,
  addAnswer,
  getCompanyInfo,
  getJobInfo,
  queryQuestionList,
  answerListQuery,
  get51JobWxConfig,
  queryComActivityCompany,
  getSendResumeCollectDataQuery,
  popWindowCollectDataQuery,
  saveCollectData,
  activityCreatorInfo,
  creatorActivityList,
  creatorFollowSet,
  aiAssistantToken,
  rewardInfoQuery,
  receiveAward,
  wechatQRCode,
  followAdd,
  getBySubject,
  delSubscribe,
  viewTime,
  lotteryTimes,
  darwLottery,
  queryWinRecords,
  submitWinInfo,
  getSignInList,
  signIn,
  getWinAwardList,
  updateWinAward,
  getSubscribeInfo,
  addBatch,
  checkGiftCondition,
  getAddresses,
  getCrossCityList
};
